// Imported from avn-native
// 0 - imperial
// 1 - metric

export const round = (num, decimals) => {
  const n = Math.pow(10, decimals);
  return Math.round(num * n) / n;
};

export const isSkinfold = (key) => key.endsWith("_skinfold");

export const getMeasurementMultiplier = (prevUnits, nextUnits) => {
  if (prevUnits === nextUnits) {
    return 1;
  }
  if (prevUnits === 0) {
    return 2.54;
  } else {
    return 1 / 2.54;
  }
};

export const useMeasurementConvert = (use_metric_units) => {
  const units = use_metric_units;
  const unitsStr = units === 1 ? "centimeters" : "inches";
  const prepareForDisplay = (code, val) => {
    if (isSkinfold(code)) {
      return val;
    } else {
      //Assume that measurements are stored in metric units
      return round(val * getMeasurementMultiplier(1, units), 2);
    }
  };
  const getUnits = (code) => {
    if (isSkinfold(code)) {
      return "mm";
    } else {
      return unitsStr;
    }
  };
  return { prepareForDisplay, unitsStr, getUnits };
};

export const convertMeasurement = ({
  key,
  val,
  sourceUnit,
  targetUnits,
  multiplier,
}) => {
  if (isSkinfold(key)) {
    return val;
  }
  const computedMultiplier =
    multiplier || getMeasurementMultiplier(sourceUnit, targetUnits);
  return round(val * computedMultiplier, 2);
};

export const deleteEmptyKeys = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (!obj[key]) {
      delete obj[key];
    }
  });
};
export const convertMeasurementDataUnits = (
  inputData,
  sourceUnit,
  targetUnits
) => {
  let multiplier = getMeasurementMultiplier(sourceUnit, targetUnits);

  if (multiplier !== 1) {
    const newData = { ...inputData };

    Object.keys(newData)
      .filter((key) => !isSkinfold(key))
      .filter((key) => key !== "report_date")
      .forEach((key) => {
        if (newData[key]) {
          newData[key] = convertMeasurement({
            key,
            multiplier,
            val: newData[key],
          });
        }
      });
    return newData;
  }
  return inputData;
};

const tapeCodes = [
  "neck",
  "chest",
  "bust",
  "waist_natural",
  "waist_belly",
  "hips",
  "left_bicep",
  "left_forearm",
  "left_thigh",
  "left_calf",
  "right_bicep",
  "right_forearm",
  "right_thigh",
  "right_calf",
];
const caliperCodes = [
  "chest_skinfold",
  "abdominal_skinfold",
  "tricep_skinfold",
  "suprailiac_skinfold",
  "thigh_skinfold",
  "chest_skinfold",
  "axilla_skinfold",
  "tricep_skinfold",
  "subscapular_skinfold",
  "abdominal_skinfold",
  "suprailiac_skinfold",
  "thigh_skinfold",
];
export const filterData = (inputData, showTape, showCaliper) => {
  const newData = { ...inputData };
  if(!showTape) {
    for(const code in newData) {
      if(tapeCodes.includes(code)) {
        delete newData[code]
      }
    }
  }
  if(!showCaliper) {
    for(const code in newData) {
      if(caliperCodes.includes(code)) {
        delete newData[code]
      }
    }
  }
  return newData;
};
